export const NOTIFICATION_TYPE_PAYMENT_STATUS = 'payment-status'
export const NOTIFICATION_TYPE_DELIVERY_STATUS = 'delivery-status'
export const NOTIFICATION_TYPE_CUSTOMER_DISPUTE_MESSAGE = 'customer-dispute-message'

const NOTIFICATION_ICON = {
  [NOTIFICATION_TYPE_PAYMENT_STATUS]: 'payment',
  [NOTIFICATION_TYPE_DELIVERY_STATUS]: 'local_shipping',
  [NOTIFICATION_TYPE_CUSTOMER_DISPUTE_MESSAGE]: 'comment'
}

const NOTIFICATION_TITLE = {
  [NOTIFICATION_TYPE_PAYMENT_STATUS]: 'Estado de Pago',
  [NOTIFICATION_TYPE_DELIVERY_STATUS]: 'Estado del envío',
  [NOTIFICATION_TYPE_CUSTOMER_DISPUTE_MESSAGE]: 'Mesaje en la reclamación'
}

export function getNotificationIcon (type) {
  return NOTIFICATION_ICON[type] ? NOTIFICATION_ICON[type] : 'notifications'
}

export function getNotificationTitle (type) {
  return NOTIFICATION_TITLE[type] ? NOTIFICATION_TITLE[type] : 'Notificación'
}
